/**
 * 全局配置
 */

// 客SaaS 私有化部署域名列表
const sassPrivateDomains = [
  'https://skydome-xn-dev.znlh.work',
  'https://saas-private.znlh.work',
  'https://wzgl-sbzl-beta.ynjtszh.com',
];

// 是否为 客SaaS 私有化
// true：客SaaS私有化环境
// false：走原有 逻辑
export const isCustomerSaasPrivate = () => sassPrivateDomains.includes(window.location.origin);

const sassPublicDomains = [
  'https://skydome-dev.znlh.work',
  'https://skydome-sit.znlh.work',
  'https://skydome.znlhzl.cn',
];
// 是否为 客SaaS 租户
// true：客saas
// false：其他
export const isCustomerSaas = () => [...sassPrivateDomains, ...sassPublicDomains].includes(window.location.origin);
